export const SECURITE_LESSONS_PT = [
  {
    id: 'securite-1',
    numero: 1,
    titre: "Criar uma palavra-passe forte",
    sousTitre: "Proteger as suas contas",
    contexte: "A palavra-passe é a chave das suas contas. Como escolher uma palavra-passe forte e fácil de memorizar ao mesmo tempo?",
    explication: [
      "**Mínimo 12 caracteres**: quanto mais longa, mais difícil de adivinhar. 12 caracteres é o mínimo recomendado.",
      "**Método das três palavras**: escolha 3 palavras aleatórias e junte-as — por exemplo 'árvore!carro#lua2026'. Fácil de memorizar e difícil de descobrir.",
      "**Não use**: o seu nome, data de nascimento, '123456', 'azerty' — são as primeiras combinações que os piratas tentam.",
      "**Uma palavra-passe por conta**: não use a mesma em todo o lado. Se um site for comprometido, as outras contas ficam seguras.",
      "**Gestor de palavras-passe**: aplicações como Bitwarden (gratuito) guardam todas as suas palavras-passe em segurança — não precisa de as memorizar.",
    ],
    question: "Qual o comprimento mínimo recomendado para uma palavra-passe?",
    options: [
      { id: 'a', text: "12 caracteres", correct: true },
      { id: 'b', text: "6 caracteres", correct: false },
      { id: 'c', text: "8 caracteres", correct: false },
    ],
    explication_reponse: "12 caracteres é o mínimo para uma boa segurança. Uma palavra-passe com 12 caracteres aleatórios precisaria de milhares de anos para ser descoberta por força bruta.",
  },
  {
    id: 'securite-2',
    numero: 2,
    titre: "Reconhecer a fraude electrónica",
    sousTitre: "Não caia na armadilha",
    contexte: "Uma SMS ou email avisa de uma encomenda, multa ou prémio... Como reconhecer a fraude?",
    explication: [
      "**Fraude de encomendas**: mensagem 'a sua encomenda está à espera, pague 2€ para a receber'. Se não esperar nenhuma encomenda, ignore completamente.",
      "**Fraude de multa**: SMS dizendo que deve uma multa de trânsito ou fiscal com link para pagar. As entidades oficiais não enviam links de pagamento por SMS.",
      "**Sinais de fraude**: urgência ('aproveite a oferta em 24 horas'), erros ortográficos, links estranhos, pedido de dados bancários.",
      "**Para denunciar**: encaminhe a mensagem suspeita para 33700 (SMS) ou signal-spam.fr (email). Gratuito e importante.",
      "**Em caso de dúvida**: não clique em nenhum link — vá directamente ao site oficial para verificar.",
    ],
    question: "Recebeu uma SMS pedindo 2€ para receber uma encomenda. O que deve fazer?",
    options: [
      { id: 'a', text: "Ignorar e denunciar para 33700", correct: true },
      { id: 'b', text: "Pagar se estiver à espera de uma encomenda", correct: false },
      { id: 'c', text: "Clicar no link para verificar", correct: false },
    ],
    explication_reponse: "Esta é uma fraude clássica. As empresas de transporte legítimas não pedem pagamento por SMS com link. Denuncie para 33700 — número gratuito para denunciar fraudes.",
  },
  {
    id: 'securite-3',
    numero: 3,
    titre: "Proteger os seus dados pessoais",
    sousTitre: "O que partilha e o que não partilha",
    contexte: "A internet pede constantemente os seus dados. Como proteger as suas informações pessoais?",
    explication: [
      "**Princípio da minimização**: não dê mais dados do que o estritamente necessário. Um site de comparação de preços não precisa do seu número de telemóvel.",
      "**O cadeado verde 🔒**: verifique se está presente na barra de endereço (https) antes de introduzir qualquer informação sensível — significa ligação encriptada.",
      "**RGPD**: a lei europeia dá-lhe o direito de saber, corrigir e apagar os seus dados pessoais em qualquer site.",
      "**Redes sociais**: configure as definições de privacidade para 'apenas amigos'. Não publique fotos dos seus documentos oficiais.",
      "**Redes WiFi públicas**: não aceda às contas bancárias ou administrativas numa rede WiFi pública (café, aeroporto).",
    ],
    question: "O que significa o cadeado verde 🔒 na barra de endereço de um site?",
    options: [
      { id: 'a', text: "A ligação é encriptada e os seus dados estão protegidos", correct: true },
      { id: 'b', text: "O site é oficial e aprovado pelo governo", correct: false },
      { id: 'c', text: "O site é gratuito para utilizar", correct: false },
    ],
    explication_reponse: "O cadeado significa que a ligação entre o telemóvel e o site é encriptada — ninguém pode interceptar os dados. Mas não garante necessariamente que o site é de confiança — apenas que a ligação é segura.",
  },
  {
    id: 'securite-4',
    numero: 4,
    titre: "O que fazer em caso de problema?",
    sousTitre: "Passos de emergência",
    contexte: "Pensa ter caído numa fraude ou a conta foi pirateada. O que fazer agora?",
    explication: [
      "**Mude a palavra-passe imediatamente**: se suspeitar de uma conta comprometida, mude a palavra-passe de imediato noutro dispositivo.",
      "**Contacte o banco**: se deu dados bancários, ligue imediatamente para o banco para bloquear o cartão. O número está no verso do cartão.",
      "**cybermalveillance.gouv.fr**: o site oficial francês de ajuda em casos de pirataria e fraude digital — gratuito.",
      "**Queixa na polícia**: para fraude financeira, dirija-se à esquadra de polícia ou Gendarmerie para apresentar uma queixa formal. Necessário para reclamar indemnização.",
      "**Não pague o resgate**: se lhe pedirem dinheiro para recuperar os ficheiros encriptados (ransomware), não pague — contacte cybermalveillance.gouv.fr.",
    ],
    question: "Descobriu que a conta bancária pode ter sido comprometida. Qual é o primeiro passo?",
    options: [
      { id: 'a', text: "Contactar o banco imediatamente para bloquear o cartão", correct: true },
      { id: 'b', text: "Aguardar uma mensagem do banco antes de agir", correct: false },
      { id: 'c', text: "Mudar primeiro a palavra-passe do email", correct: false },
    ],
    explication_reponse: "O banco é o primeiro a contactar em caso de suspeita de roubo de dados bancários. Pode bloquear o cartão de imediato para impedir qualquer operação ilegítima.",
  },
];
